// export const urlDocument = "http://localhost:3333/c/v";
// export const cdnUrl = "http://localhost:3333/";

export const urlDocument = "http://152.42.176.5/c/v";
export const cdnUrl = "http://152.42.176.5/";
